import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { advanceConfigOptions } from '../..'
import { getShortUserName, isBuisenessOwnerRepectToExperiment, isMyExperiment } from '../../../../_common/functions'
import { OptionI } from '../../../../_config/types'
import Icon from '../../../../components/icons'
import MteCards from '../HeaderSection/MteCards'
import DmlCards from '../HeaderSection/DMLCards'
import Text from '../../../../elements/Typo/Text'
import { ExperimentDetailsHeaderProps } from '../../types'
import HeaderCardsMini from '../HeaderSection/CardsMini'
import DownloadFiles from '../HeaderSection/DownloadFiles'
import Filter from '../HeaderSection/Filter'
import MoreActions from '../HeaderSection/MoreActions'
import AdvanceConfigurationButton from '../advanceConfigurationButton'
import { EXPERIMENT_TYPES } from '../../../../_common/constant'

const HeaderSmallView: React.FC<ExperimentDetailsHeaderProps> = ({
    experimentDetails,
    groupOptions,
    selectedGroup,
    setSelectedGroup,
    dropdownOptions,
    selectedKPI,
    setSelectedKPI,
    setSelectedDateRange,
    selectedDateRange,
    setSelectedConfig,
    setShowAlertMsg,
    user,
    comments,
    mteCardData,
    dmlCardData,
    openComment,
    selectedConfig,
    nMatches,
    cliper,
    MeasurementAdvanceConfig,
    getCStatus,
    cardDetails,
    analysisData,
    _handleShowExperimentStatus,
    setIsInconclusiveModalOpen,
    setIsNoImpactModalOpen,
    toDownloadAsReport,
    onUpdate,
}) => {
    const { t } = useTranslation()
    const [headerExpend, setHeaderExpend] = useState<boolean>(true)
    const isContinuousKpi = selectedKPI?.kpi_type === 'Continuous'
    const getHeaderCards = () => {
        if (experimentDetails?.experiment_type?.title == EXPERIMENT_TYPES.MTE.title) {
            return <MteCards mteCardData={mteCardData} miniview={true} />
        }
        if (experimentDetails?.experiment_type?.title == EXPERIMENT_TYPES.DML.title) {
            return <DmlCards dmlCardData={dmlCardData} miniview={true} />
        }
        return <HeaderCardsMini cardDetails={cardDetails} experiment={experimentDetails} />
    }
    return (
        <div className={`grid grid-cols-10 gap-3 items-center `}>
            <div className="col-span-3 gap-1 flex items-center" data-aos="zoom-in" data-aos-delay="200">
                <div className="bg-[#F1F1F1] px-[0.545rem] py-[0.145rem] flex items-center gap-1 rounded-[1.818rem] truncate" title={experimentDetails?.experiment_literal}>
                    <Text className="!text-[0.591rem] font-normal">{t('ID:')}</Text>
                    <Text className="!text-[0.591rem] font-normal truncate">{experimentDetails?.experiment_literal}</Text>
                </div>
                <div className="bg-primary !text-[0.545rem] badge badge-warning font-normal"> {experimentDetails?.exp_type_status}</div>

                <Text size="xl" className="font-semibold !text-[0.909rem] truncate" title={experimentDetails?.experiment_name}>
                    {experimentDetails?.experiment_name}
                </Text>
            </div>
            <div className="col-span-3">{getHeaderCards()}</div>
            <div className="col-span-4 flex items-center gap-1 justify-end">
                <div className="flex gap-1 items-center py-[0.364rem] px-[0.545rem] border border-[#CDCDCD] rounded-[0.455rem]">
                    <Text size="xs" className="!text-[0.591rem] truncate" title={t('Created By :')}>
                        {t('Created By :')}
                    </Text>
                    <div className="flex items-center gap-1" title={experimentDetails?.user?.first_name + ' ' + experimentDetails?.user?.last_name}>
                        <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                            <span className="font-bold text-[0.455rem]">{getShortUserName(experimentDetails?.user?.first_name, experimentDetails?.user?.last_name)}</span>
                        </div>
                        <div className="max-w-[2.909rem]">
                            <Text size="xs" className="font-semibold !text-[0.591rem] truncate">
                                {experimentDetails?.user?.first_name + ' ' + experimentDetails?.user?.last_name}
                            </Text>
                        </div>
                    </div>
                </div>
                {isContinuousKpi && (
                    <AdvanceConfigurationButton
                        selectedConfig={selectedConfig}
                        setSelectedConfig={setSelectedConfig}
                        experimentDetails={experimentDetails}
                        nMatches={nMatches}
                        cliper={cliper}
                        MeasurementAdvanceConfig={MeasurementAdvanceConfig}
                        getCStatus={getCStatus}
                    />
                )}
                <DownloadFiles experiment={experimentDetails} />
                <Filter
                    experiment={experimentDetails}
                    groupOptions={groupOptions}
                    selectedGroup={selectedGroup}
                    onGroupChange={(e: OptionI) => setSelectedGroup(e)}
                    kpiOptions={dropdownOptions}
                    selectedKPI={selectedKPI ? [selectedKPI] : []}
                    setShowAlertMsg={setShowAlertMsg as any}
                    onKpiChange={(e: any) => {
                        setSelectedKPI(e)
                        setSelectedConfig(e.kpi_type === 'Continuous' ? advanceConfigOptions[0] : undefined)
                    }}
                    onDateChange={(e: any) => {
                        if (e?.length) {
                            setSelectedDateRange(e)
                        } else {
                            setSelectedDateRange([])
                        }
                    }}
                    selectedDateRange={selectedDateRange}
                    shortView={true}
                    toDownloadAsReport={false}
                />
                <MoreActions
                    data-testid="more-actions"
                    experiment={experimentDetails}
                    isEnabledReviewNote={isBuisenessOwnerRepectToExperiment(experimentDetails, user?.user_literal) && !isMyExperiment(experimentDetails, user?.user_literal)}
                    isEnabledViewNote={isMyExperiment(experimentDetails, user?.user_literal) && comments.length > 0}
                    openComment={openComment}
                    experimentStatusDetails={cardDetails?.experiment_status?.split('_').join(' ') || '-'}
                    viewDetails={_handleShowExperimentStatus as any}
                />
                <Icon name={headerExpend ? 'down' : 'up'} onClick={() => setHeaderExpend(!headerExpend)}></Icon>
            </div>
        </div>
    )
}

export default HeaderSmallView
